export default {
  "b2b.auth.unauthorized.first-row": "Nemáte dostatečná oprávnění",
  "b2b.auth.unauthorized.second-row":
    "Kontaktujte, prosím, oddělení zákaznických služeb ZCV"
};
